import { GridFilterValue, StringFilterOperator } from './operators';
import { ScalarFilterValue } from './types';
import { DataGridFilterValue, isStringArray } from './types';
import { neverReached } from 'shared/utils/neverReached';

export function matchesStringFilter(
  operator: StringFilterOperator,
  filterValue: DataGridFilterValue,
  cellValue: ScalarFilterValue
): boolean {
  const stringCell = normalizeString(String(cellValue ?? ''));

  switch (operator) {
    case GridFilterValue.CONTAINS:
      return stringCell.includes(normalizeString(String(filterValue ?? '')));
    case GridFilterValue.NOT_CONTAINS:
      return !stringCell.includes(normalizeString(String(filterValue ?? '')));
    case GridFilterValue.EQUALS:
    case GridFilterValue.IS:
      return stringCell === normalizeString(String(filterValue ?? ''));
    case GridFilterValue.NOT_EQUALS:
    case GridFilterValue.NOT:
      return stringCell !== normalizeString(String(filterValue ?? ''));
    case GridFilterValue.STARTS_WITH:
      return stringCell.startsWith(normalizeString(String(filterValue ?? '')));
    case GridFilterValue.ENDS_WITH:
      return stringCell.endsWith(normalizeString(String(filterValue ?? '')));
    case GridFilterValue.IS_EMPTY:
      return stringCell.length === 0;
    case GridFilterValue.IS_NOT_EMPTY:
      return stringCell.length > 0;
    case GridFilterValue.IS_ANY_OF:
      return isStringArray(filterValue)
        ? filterValue
            .map(normalizeString)
            .includes(stringCell)
        : false;
    default:
      return neverReached(operator);
  }
}

function normalizeString(str: string): string {
  return str.trim().replace(/\s+/g, ' ').replace(/\n/g, ' ').toLowerCase();
}
